module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Reportes de vacaciones")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitudes",
    staticClass: "box position-relative"
  }, [_c('lista-solicitud-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaEmpleados) ? _c('div', {
    key: "lista_empleados",
    staticClass: "box"
  }, [_c('lista-empleados-vacaciones', {
    on: {
      "close": function($event) {
        _vm.mostrarListaEmpleados = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-285f1573","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Vacaciones_Reporte.vue
// module id = 844
// module chunks = 0